<template>
  <div class="container">
    <van-tabs sticky color="#14CC80" v-model="isShow">
      <van-tab title="直流" :name="1" v-if="dc > 0 || noPile"> </van-tab>
      <van-tab title="交流" :name="2" v-if="ac > 0 || noPile"> </van-tab>
      <van-tab title="延时费(直)" :name="3" v-if="dc > 0 && dcDelayPriceList.length > 0 || noPile && dcDelayPriceList.length > 0"> </van-tab>
      <van-tab title="延时费(交)" :name="4" v-if="ac > 0 && acDelayPriceList.length > 0 || noPile && acDelayPriceList.length > 0"> </van-tab>
    </van-tabs>
    <div class="rate-table" v-if="isShow == 1">
      <div class="rate-table-th">
        <div class="rate-table-td">时段</div>
        <div class="rate-table-td">电费(元/度)</div>
        <div class="rate-table-td">服务费(元/度)</div>
        <div class="rate-table-td">单价(元/度)</div>
      </div>
      <div
        class="rate-table-row"
        v-for="(item, index) in dcFeeList"
        :key="index"
      >
        <div class="rate-table-td">
          {{ $common.formatDelayTime(item.beginTime) }}~{{
            $common.formatDelayTime(item.endTime)
          }}
        </div>
        <div class="rate-table-td number">{{ item.slotElecPrice }}</div>
        <div class="rate-table-td number">{{ item.slotServicePrice }}</div>
        <div class="rate-table-td number">
          {{
            item.slotElecPrice + item.slotServicePrice | getNumber(4)
          }}
        </div>
      </div>
      <div class="rate-table-row" v-if="dcFeeList.length == 0">
        <div class="rate-table-td no-list-data">暂无费率</div>
      </div>
    </div>
    <div class="rate-table" v-else-if="isShow == 2">
      <div class="rate-table-th">
        <div class="rate-table-td">时段</div>
        <div class="rate-table-td">电费(元/度)</div>
        <div class="rate-table-td">服务费(元/度)</div>
        <div class="rate-table-td">单价(元/度)</div>
      </div>
      <div
        class="rate-table-row"
        v-for="(item, index) in acFeeList"
        :key="index"
      >
        <div class="rate-table-td">
          {{ $common.formatDelayTime(item.beginTime) }}~{{
            $common.formatDelayTime(item.endTime)
          }}
        </div>
        <div class="rate-table-td number">{{ item.slotElecPrice }}</div>
        <div class="rate-table-td number">{{ item.slotServicePrice }}</div>
        <div class="rate-table-td number">
          {{
            item.slotElecPrice + item.slotServicePrice | getNumber(4)
          }}
        </div>
      </div>
      <div class="rate-table-row" v-if="acFeeList.length == 0">
        <div class="rate-table-td no-list-data">暂无费率</div>
      </div>
    </div>

    <div class="rate-table" v-else-if="isShow == 3">
      <div class="rate-table-th">
        <div class="rate-table-td">时段</div>
        <div class="rate-table-td">延时费(元/分)</div>
      </div>
      <div
        class="rate-table-row"
        v-for="(item, index) in dcDelayPriceList"
        :key="index"
      >
        <div class="rate-table-td">
          {{ $common.formatDelayTime(item.beginTime) }}~{{
            $common.formatDelayTime(item.endTime)
          }}
        </div>
        <div class="rate-table-td number">{{ item.slotDelayPrice }}</div>
      </div>
      <div class="rate-table-row" v-if="dcDelayPriceList.length == 0">
        <div class="rate-table-td no-list-data">暂无费率</div>
      </div>
    </div>
    <div class="rate-table" v-else-if="isShow == 4">
      <div class="rate-table-th">
        <div class="rate-table-td">时段</div>
        <div class="rate-table-td">延时费(元/分)</div>
      </div>
      <div
        class="rate-table-row"
        v-for="(item, index) in acDelayPriceList"
        :key="index"
      >
        <div class="rate-table-td">
          {{ $common.formatDelayTime(item.beginTime) }}~{{
            $common.formatDelayTime(item.endTime)
          }}
        </div>
        <div class="rate-table-td number">{{ item.slotDelayPrice }}</div>
      </div>
      <div class="rate-table-row" v-if="acDelayPriceList.length == 0">
        <div class="rate-table-td no-list-data">暂无费率</div>
      </div>
    </div>

    <div class="delay-free-minutes" v-if="isShow == 3">
      免费时长: {{ feeDetail.dcDelayFreeMinutes }}分钟
    </div>
    <div class="delay-free-minutes" v-if="isShow == 4">
      免费时长: {{ feeDetail.acDelayFreeMinutes }}分钟
    </div>
  </div>
</template>

<script>
import { Tabs, Tab } from "vant";
import { getStationDetailFee } from "@/common/api";
export default {
  name: "station-fee-details",
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
  },
  data() {
    return {
      isShow: 0,
      feeDetail: null,
      staPkId: "",
      type: "",
      ac: 0,
      dc: 0,
      acFeeList: [],
      dcFeeList: [],
      acDelayPriceList: [],
      dcDelayPriceList: [],
      noPile: false, // 没有桩的情况显示所有费率
    };
  },

  mounted() {
    let options = this.$route.query;
    this.staPkId = options.staPkId;
    this.type = options.type;
    this.ac = options.ac || 0;
    this.dc = options.dc || 0;
    this.noPile = options.ac == 0 && options.dc == 0;
    if(this.ac > 0 && this.dc == 0){
        this.isShow = 2
    }
    this.getStationDetailFee();
  },
  methods: {
    async getStationDetailFee() {
      let ret = await getStationDetailFee({
        staPkId: this.staPkId,
      });
      if (ret.data.length > 0) {
        this.feeDetail = ret.data[0];
        this.getFeeList();
      } else {
        this.feeDetail = {};
      }
    },
    getFeeList() {
      let feeDetail = this.feeDetail;
      let acFeeList = [];
      let dcFeeList = [];
      let acDelayPriceList = [];
      let dcDelayPriceList = [];
      if (this.ac > 0 || this.noPile) {
        // 交流 有桩才显示
        if (feeDetail.campaignAcElecPricePartDescPos && this.type != "ent") {
          // 交流活动调价
          acFeeList = feeDetail.campaignAcElecPricePartDescPos || [];
        } else {
          if (this.type == "ent") {
            // 企业费率
            acFeeList = feeDetail.entAcElecPricePartDescPos;
          } else {
            // 正常费率
            acFeeList = feeDetail.acElecpricePartDescPos;
          }
        }
        // 延时费, 没有站点调价

        if (this.type == "ent") {
          // 企业费率
          acDelayPriceList = feeDetail.entAcDelayPricePartDescPos || [];
        } else {
          // 正常费率
          acDelayPriceList = feeDetail.acDelayPricePartDescPos || [];
        }
      }

      if (this.dc > 0 || this.noPile) {
        // 直流 有桩才显示
        if (
          feeDetail.campaignDcElecPricePartDescPos &&
          this.type != "ent"
        ) {
          // 直流活动调价
          dcFeeList = feeDetail.campaignDcElecPricePartDescPos;
        } else {
          if (this.type == "ent") {
            // 企业费率
            dcFeeList = feeDetail.entDcElecPricePartDescPos;
          } else {
            // 正常费率
            dcFeeList = feeDetail.dcElecpricePartDescPos;
          }
        }

        // 延时费, 没有活动调价

        if (this.type == "ent") {
          // 企业费率
          dcDelayPriceList = feeDetail.entDcDelayPricePartDescPos || [];
        } else {
          // 正常费率
          dcDelayPriceList = feeDetail.dcDelayPricePartDescPos || [];
        }
      }

      this.acFeeList = acFeeList;
      this.dcFeeList = dcFeeList;
      this.acDelayPriceList = acDelayPriceList;
      this.dcDelayPriceList = dcDelayPriceList;
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background: #efeff4;
}

.delay-free-minutes {
  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #333;
  padding: 0.2rem 0.3rem 0.1rem 0.2rem;
}
.rate-table {
  margin: 0.1rem;
  font-size: 0.28rem;
  line-height: 0.5rem;
  border-radius: 0.1rem 0.1rem 0px 0px;
  overflow: hidden;
  background-color: #fff;
  color: #333;
}
.rate-table-th,
.rate-table-row {
  display: flex;
}
.rate-table-th,
.rate-table-td {
  flex: 1;
}
.rate-table-td {
  padding: 0 0.1rem;
}
.rate-table-th {
  background: rgba(20, 204, 128, 0.1);
  color: #666;
  font-size: 0.26rem;
}
.rate-table-row .rate-table-td {
  border-right: 1px solid #efeff4;
}
.rate-table-row .rate-table-td:last-child {
  border-right: none;
}
.rate-table-row {
  border-bottom: 1px solid #efeff4;
}
.rate-table-row:last-child {
  border-bottom: none;
}

.rate-table-td.number {
  font-size: 0.34rem;
}
</style>
